export default __webpack_public_path__ + "static/media/pexels-thought-catalog-2228552.0a50b650.jpg";